<!-- order-list-detail -->

<template>
  <div class="mt2 content-box">
    <div v-for="(order, index) of orderDetail" :key="index" :class="index > 0 ? 'mt10' : ''" class="goods-box">
      <div class="tab-content">
        <slot :goodsList="order" name="goods-content">
          <div style="
              text-align: right;
              font-size: 12px;
              color: #f00;
              margin-bottom: 5px;
              overflow: hidden;            ">
            <div style="float: left; color: #919191">
              下单时间：{{ order.createTime }}
            </div>
            <span v-if="order.statusPay === 0 && order.statusOrder === 0 && !isFinish">等待买家付款</span>
            <span v-if="order.statusPay === 1">已支付</span>
            <span v-if="order.statusPay === 4">已退款</span>
            <span v-if="order.statusExpress === 2">已发货</span>
            <span v-if="order.statusOrder === 1 || order.statusOrder === 2">取消审核中</span>
            <span v-if="order.statusOrder === 3 || (isFinish && order.statusPay === 0 && order.statusOrder === 0)"
              style="color: #919191">已取消</span>
          </div>


          <div v-for="goods of order.goods" :key="goods.goodsName">
            <van-card :desc="`规格：${Array.isArray(goods.spec) ? goods.spec.join(',') : ''}`" :num="goods.goodsQuantity"
              :thumb="goods.goodsHeadImage" style="background: #fff">
              <template #title>
                <span style="font-weight: 800" @click="order2detail(order)">{{
                  goods.goodsName
                }}</span>
              </template>

              <template #price>
                <div v-if="order.cardQuantity < 1">
                  <img class="price-icon"
                    src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" />
                  <span style="font-size: 14px">{{ goods.goodsPrice | money }}</span>
                </div>
                <div v-else></div>
              </template>
            </van-card>
          </div>

          <div v-if="order.goodsType === 'TICKET'">
            <van-card :num="order.goodsQuantity" :thumb="order.goodsHeadImage" style="background: #fff">
              <template #title>
                <span style="font-weight: 800" @click="order2detail(order)">{{
                  order.goodsName
                }}</span>
              </template>

              <template #price>
                <img class="price-icon"
                  src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" />
                <span style="font-size: 14px">{{ order.goodsPrice | money }}</span>
              </template>
            </van-card>
          </div>
        </slot>

        <div style="font-size: 12px">
          <slot :orderInfo="order" name="order-info"></slot>
          <van-cell v-if="order.statusExpress > 0" :is-link="order.statusExpress === 2" icon="logistics"
            style="font-size: 12px" @click="showExpressInfo(order.expressInfo)">
            <template #title>
              <span v-if="order.statusExpress === 1">待发货</span>
              <span v-else-if="order.statusExpress === 2">已发货</span>
            </template>
            <span v-if="order.statusExpress === 2">查看详情</span>
          </van-cell>

          <van-cell v-if="order.splitDate" icon="info-o" is-link label="因仓库发货原因，订单已自动拆分" style="font-size: 12px"
            title="订单已拆分" value="查看详情" @click="showSubOrder(order.orderId)">
          </van-cell>


          <van-cell title="合计">
            <template>
              <img class="price-icon"
                src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" /><span
                style="font-size: 16px">{{ order.fee | money
                }}</span>
            </template>
          </van-cell>


          <slot :orderInfo="order" name="order-ext-info"></slot>
        </div>

        <div v-if="order.statusPay === 0 && order.statusOrder === 0 && !isFinish" class="flex-row row-between btn-box">
          <div v-if="!order.cardPayResult" style="
            display: flex;
            align-items: center;
            margin-right: 10px;
            font-size: 12px;
            flex: 1;
          ">
            剩余时间：
            <van-count-down :time="order.countDown" format="mm 分 ss 秒" @finish="finish(order)" />
          </div>
          <div class="flex-row" style="flex: 1; justify-content: flex-end">
            <div @click="order2detail(order)" class="btn-base btn-enter budo-103"> 立即支付 </div>
            <div class="btn-base btn-delete" style="margin-left: 8px" @click="cancelOrder(order.orderId)">
              取消订单
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-dialog v-model="showExpressInfoFlag" :show-cancel-button="false" confirm-button-text="关闭" message-align="left"
      style="padding: 4px" title="快递信息">
      <express-info v-if="showExpressInfoFlag" :exp-info="expInfo"></express-info>
    </van-dialog>

    <van-popup v-model="showSubOrderFlag" :style="{ height: '50%' }" position="bottom">
      <sub-order-list :order-id="parentOrderId" @showExpInfo="showExpressInfo"></sub-order-list>
    </van-popup>
  </div>
</template>

<script>
import { wx_cancel_order } from "@/api/goods-api";
import { Toast } from "vant";
import { buyDetail } from "@/util/orders";
import Clipboard from 'clipboard';
import ExpressInfo from "@/views/user-center/order-list/goods/express-info";
import SubOrderList from "@/views/user-center/order-list/goods/sub-order-list";

export default {
  name: "order-list-detail",

  components: { SubOrderList, ExpressInfo },

  props: {
    orderDetail: {
      type: Array,
      default: () => {
        return [];
      },
      require: true,
    },

    orderListUrl: { type: String, default: 'user-center-order-list-goods' }
  },

  data() {
    return {
      isFinish: false,
      showExpressInfoFlag: false,
      showSubOrderFlag: false,
      expressInfo: {},
      expressDetail: {},
      parentOrderId: '',
      expInfo: {}
    };
  },

  methods: {
    showExpressInfo(info) {
      if (info) {
        this.showExpressInfoFlag = true;
        this.expInfo = info;
      }
    },

    showSubOrder(orderId) {
      this.parentOrderId = orderId;
      this.showSubOrderFlag = true;
    },

    copy() {
      const clipboard = new Clipboard('.copy-orderid');
      clipboard.on('success', e => {
        budo_log.info('#192 复制成功')
        //  释放内存
        clipboard.destory()
      })
      clipboard.on('error', e => {
        // 不支持复制
        budo_log.info('#198 该浏览器不支持复制')
        // 释放内存
        clipboard.destory()
      })
    },

    order2detail(data) {
      let arr = [];
      for (let i in data.goods) {
        arr.push({
          count: 1,
          checked: true,
          goods: {
            goodsId: data.goods[i].goodsId,
            img: data.goods[i].goodsHeadImage,
            name: data.goods[i].goodsName,
            price: data.goods[i].goodsPrice,
            spec: data.goods[i].spec,
          },
        });
      }

      budo_log.info("#219", data);
      buyDetail(1, arr, data.goodsType);
      this.$router.push({
        path: "user-center-order-submit-detail",
        query: {
          is_pay: +(data.wxPayResult ? 1 : 0),
          goodsType: data.goodsType,
          orderId: data.orderId,
        },
      });
      sessionStorage.setItem("orderInfo", JSON.stringify(data));
    },

    finish(order) {
      budo_log.info("#232 倒计时结束");
      // this.$emit("update");
      if (order.cardPayResult) {
        return;
      }
      this.isFinish = true;
    },

    cancelOrder(orderId) {
      wx_cancel_order(orderId).then((res) => {
        if (res.code === 0 && res.data === true) {
          Toast({ message: "取消订单成功", duration: 1000 });
          this.$emit("update");
          this.$router.push(this.orderListUrl);
        } else {
          Toast({ message: "取消订单失败：" + res.msg, duration: 1000 });
        }

        this.$router.go(0)
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-page {
  background-color: #edf0f5;
  padding-bottom: 120px;

  .content-box {
    .tab-content {
      padding: 10px 15px;
      background-color: white;

      .goods-box {
        color: #333333;

        .goods-msg-box {
          padding: 10px 14px;
        }
      }
    }

    .btn-box {
      background-color: white;
      padding: 10px 14px;
    }
  }

  .btn-base {
    $height: 30px;
    width: 80px;
    height: $height;
    border-radius: 15px;
    font-size: 13px;
    color: white;
    text-align: center;
    line-height: $height;
  }

  .btn-enter {
    background: #fc3f3f;
  }

  .btn-delete {
    background: #919191;
  }
}

.price-icon {
  width: 18px;
  height: 18px;
  margin-top: -2px;
  margin-right: 1px;
}
</style>
